import { render } from "./umbraco.vue?vue&type=template&id=94476992"
import script from "./umbraco.vue?vue&type=script&lang=js"
export * from "./umbraco.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__